import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Select, Pagination, Result } from 'antd';
import CampaignCardComponent from '../../components/Brand/Campaign/CampaignCardComponent';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { CampaignList } from '../../apis/Brand/Campaigns/CampaignList';
import { useGlobalState } from '../../store/state';
import { CampaignDelete } from '../../apis/Brand/Campaigns/CampaignDelete';
import PlatformIconRender from '../../components/Common/PlatformIconRender';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function useQuery () {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const BrandCampaignPage = (props) => {
  const params = useParams();
  const query = useQuery();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const history = useHistory();
  console.log('history', history);
  const [campList, setCampList] = useState({
    campaigns: [],
  });
  const [baseConfig, setBaseConfig] = useState({
    type: query.get('status') || 'all',
    page: 1,
  });
  const getCampiagnList = () =>{
    CampaignList(
      user.accessToken,
      company.selected.id,
      { type: baseConfig.type, page: baseConfig.page },
    ).then(({ response })=>{
      console.log('retrived Data', response);
      setCampList({
        ...campList,
        ...response,
      });
    });
  };
  useEffect(() =>{
    setBaseConfig({
      ...baseConfig,
      type: query.get('status') || 'all',
    });
    changeCampaignType(query.get('status') || 'all');
    getCampiagnList();
  }, [baseConfig.type, baseConfig.page, history.location.search]);

  // const renderPlatform = (platform)=>{ // render platform icons
  //     switch(platform){
  //         case 'youtube': return <FaYoutube/>
  //         case 'instagram':return <FaInstagram/>
  //         case 'facebook': return <FaFacebookF/>
  //         case 'twitter': return <FaTwitter/>
  //         default: return null
  //     }
  // }
  const changeCampaignType = (v) =>{ // chaning camp type
    setBaseConfig({
      ...baseConfig,
      type: v,
    });
    history.push(`/brand/${params.companyId}/campaign?status=${v}`);
  };
  const onPagingChange = (page)=>{ // pager changing
    setBaseConfig({
      ...baseConfig,
      page: page,
    });
  };

  const deleteDraft = (campId) =>{
    console.log('camp', campId);
    console.log('pars', params.companyId);
    CampaignDelete(user.accessToken, {
      campaignid: campId,
      brand: params.companyId,
    }).then(({ response }) =>{
      console.log('res', response);
      getCampiagnList();
    });
  };
  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-4">
            <p className="mb-0"><strong>Campaigns of <span style={{ textTransform: 'capitalize' }}>{company.selected.companyname}</span></strong></p>
          </div>
          <div className="col-md-8 text-right">
            <div className="text-left d-inline-block mr-md-3"
              style={{ width: 130 }} >
              <Select className="common_select w-100"
                defaultValue={baseConfig.type}
                size="large"
                onChange={changeCampaignType}>
                <Select.Option value="all">All</Select.Option>
                <Select.Option value="draft">Draft</Select.Option>
                <Select.Option value="review">In Review</Select.Option>
                <Select.Option value="published">Published</Select.Option>
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="completed">Completed</Select.Option>
                <Select.Option value="rejected">Rejected</Select.Option>
                <Select.Option value="delete">delete</Select.Option>
              </Select>
            </div>
            <Link to={`/brand/${params.companyId}/campaign/create`}
              disabled
              className="common_button outlined d-inline-block py-2">Create Campaign</Link>
          </div>
        </div>
      </BrandTopSubHeaderComponent>
      <div style={{ padding: 10 }}>
        <div className="campaign_cards">
          <div className="d-flex flex-wrap">
            {campList.campaigns.length ?
              (campList.campaigns.map((camp)=>(
                <CampaignCardComponent
                  key={camp._id}
                  status={camp.campaignstatus}
                  timeLeft={camp.startdate? moment(camp.startdate).fromNow(): 'N/A'}
                  createdOn={camp.createdAt}
                  title={camp.name}
                  campaignid={camp.campaignid}
                  deleteCampaign={deleteDraft}
                  socialIcons={<>
                    <PlatformIconRender platform={camp.platform}
                      size={20}/>
                    {/* <span>
                                            {renderPlatform(camp.platform)}
                                        </span> */}
                    {/* <span>
                                            <FaInstagram/>
                                        </span> */}
                  </>}
                  taskCount={`Total of ${camp.totalcreatives} creatives`}
                  rowData={camp}
                />
              ))) :
              (
                <div className="w-100">
                  <Result
                    title={`No Data available in ${baseConfig.type}`}
                  />
                </div>
              )
            }

          </div>
        </div>
        {
          campList.campaigns.length?
            (<Pagination
              onChange={onPagingChange}
              // defaultCurrent={1}
              current={baseConfig.page}
              total={campList.campaignsCount}
              defaultPageSize={campList.limit}
            />) :
            null
        }
      </div>
    </BrandBaseLayoutComponent>
  );
};

export default BrandCampaignPage;
